var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompetitorEditImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 410,
    viewBox: "0 0 469 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395 23.1664V126.128C395 138.814 384.514 149.295 371.819 149.295H140.007C127.313 149.295 116.826 138.814 116.826 126.128V23.1664C116.826 10.48 127.313 0 140.007 0H371.819C384.698 0 395 10.48 395 23.1664Z",
    fill: "#E3E5FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.438 30.8885V104.433H333.367V30.8885H215.438ZM332.263 39.8977H324.536V32.1755H332.263V39.8977ZM216.909 86.0466H224.636V93.7687H216.909V86.0466ZM252.785 59.0191H260.512V66.7413H252.785V59.0191ZM251.497 66.7413H243.77V59.0191H251.497V66.7413ZM278.358 66.7413H270.631V59.0191H278.358V66.7413ZM279.646 59.0191H287.373V66.7413H279.646V59.0191ZM269.343 66.7413H261.616V59.0191H269.343V66.7413ZM260.328 68.0283V75.7504H252.601V68.0283H260.328ZM261.616 68.0283H269.343V75.7504H261.616V68.0283ZM270.631 68.0283H278.358V75.7504H270.631V68.0283ZM279.646 68.0283H287.373V75.7504H279.646V68.0283ZM288.661 68.0283H296.388V75.7504H288.661V68.0283ZM288.661 66.7413V59.0191H296.388V66.7413H288.661ZM297.675 59.0191H305.403V66.7413H297.675V59.0191ZM297.675 57.7321V50.01H305.403V57.7321H297.675ZM296.204 57.7321H288.477V50.01H296.204V57.7321ZM287.373 57.7321H279.646V50.01H287.373V57.7321ZM278.358 57.7321H270.631V50.01H278.358V57.7321ZM269.343 57.7321H261.616V50.01H269.343V57.7321ZM260.328 57.7321H252.601V50.01H260.328V57.7321ZM251.497 57.7321H243.77V50.01H251.497V57.7321ZM242.482 57.7321H234.755V50.01H242.482V57.7321ZM242.482 59.0191V66.7413H234.755V59.0191H242.482ZM242.482 68.0283V75.7504H234.755V68.0283H242.482ZM243.77 68.0283H251.497V75.7504H243.77V68.0283ZM251.497 77.0375V84.7596H243.77V77.0375H251.497ZM252.785 77.0375H260.512V84.7596H252.785V77.0375ZM261.616 77.0375H269.343V84.7596H261.616V77.0375ZM270.631 77.0375H278.358V84.7596H270.631V77.0375ZM279.646 77.0375H287.373V84.7596H279.646V77.0375ZM288.661 77.0375H296.388V84.7596H288.661V77.0375ZM297.675 77.0375H305.403V84.7596H297.675V77.0375ZM297.675 75.7504V68.0283H305.403V75.7504H297.675ZM306.506 68.0283H314.233V75.7504H306.506V68.0283ZM306.506 66.7413V59.0191H314.233V66.7413H306.506ZM306.506 57.7321V50.01H314.233V57.7321H306.506ZM306.506 48.723V41.0008H314.233V48.723H306.506ZM305.219 48.723H297.492V41.0008H305.219V48.723ZM296.204 48.723H288.477V41.0008H296.204V48.723ZM287.373 48.723H279.646V41.0008H287.373V48.723ZM278.358 48.723H270.631V41.0008H278.358V48.723ZM269.343 48.723H261.616V41.0008H269.343V48.723ZM260.328 48.723H252.601V41.0008H260.328V48.723ZM251.497 48.723H243.77V41.0008H251.497V48.723ZM242.482 48.723H234.755V41.0008H242.482V48.723ZM233.467 48.723H225.74V41.0008H233.467V48.723ZM233.467 50.1938V57.916H225.74V50.1938H233.467ZM233.467 59.0191V66.7413H225.74V59.0191H233.467ZM233.467 68.0283V75.7504H225.74V68.0283H233.467ZM233.467 77.0375V84.7596H225.74V77.0375H233.467ZM234.755 77.0375H242.482V84.7596H234.755V77.0375ZM242.482 86.0466V93.7687H234.755V86.0466H242.482ZM243.77 86.0466H251.497V93.7687H243.77V86.0466ZM252.785 86.0466H260.512V93.7687H252.785V86.0466ZM261.616 86.0466H269.343V93.7687H261.616V86.0466ZM270.631 86.0466H278.358V93.7687H270.631V86.0466ZM279.646 86.0466H287.373V93.7687H279.646V86.0466ZM288.661 86.0466H296.388V93.7687H288.661V86.0466ZM297.675 86.0466H305.403V93.7687H297.675V86.0466ZM306.506 86.0466H314.233V93.7687H306.506V86.0466ZM306.506 84.7596V77.0375H314.233V84.7596H306.506ZM315.521 77.0375H323.248V84.7596H315.521V77.0375ZM315.521 75.7504V68.0283H323.248V75.7504H315.521ZM315.521 66.7413V59.0191H323.248V66.7413H315.521ZM315.521 57.7321V50.01H323.248V57.7321H315.521ZM315.521 48.723V41.0008H323.248V48.723H315.521ZM315.521 39.8977V32.1755H323.248V39.8977H315.521ZM314.233 39.8977H306.506V32.1755H314.233V39.8977ZM305.219 39.8977H297.492V32.1755H305.219V39.8977ZM296.204 39.8977H288.477V32.1755H296.204V39.8977ZM287.373 39.8977H279.646V32.1755H287.373V39.8977ZM278.358 39.8977H270.631V32.1755H278.358V39.8977ZM269.343 39.8977H261.616V32.1755H269.343V39.8977ZM260.328 39.8977H252.601V32.1755H260.328V39.8977ZM251.497 39.8977H243.77V32.1755H251.497V39.8977ZM242.482 39.8977H234.755V32.1755H242.482V39.8977ZM233.467 39.8977H225.74V32.1755H233.467V39.8977ZM224.452 39.8977H216.725V32.1755H224.452V39.8977ZM216.909 41.1847H224.636V48.9068H216.909V41.1847ZM216.909 50.1938H224.636V57.916H216.909V50.1938ZM216.909 59.0191H224.636V66.7413H216.909V59.0191ZM216.909 68.0283H224.636V75.7504H216.909V68.0283ZM216.909 77.0375H224.636V84.7596H216.909V77.0375ZM225.74 86.0466H233.467V93.7687H225.74V86.0466ZM233.467 94.8719V102.962H225.74V94.8719H233.467ZM234.755 94.8719H242.482V102.962H234.755V94.8719ZM243.77 94.8719H251.497V102.962H243.77V94.8719ZM252.785 94.8719H260.512V102.962H252.785V94.8719ZM261.616 94.8719H269.343V102.962H261.616V94.8719ZM270.631 94.8719H278.358V102.962H270.631V94.8719ZM279.646 94.8719H287.373V102.962H279.646V94.8719ZM288.661 94.8719H296.388V102.962H288.661V94.8719ZM297.675 94.8719H305.403V102.962H297.675V94.8719ZM306.506 94.8719H314.233V102.962H306.506V94.8719ZM315.521 94.8719H323.248V102.962H315.521V94.8719ZM315.521 93.5849V85.8627H323.248V93.5849H315.521ZM324.536 86.0466H332.263V93.7687H324.536V86.0466ZM324.536 84.7596V77.0375H332.263V84.7596H324.536ZM324.536 75.7504V68.0283H332.263V75.7504H324.536ZM324.536 66.7413V59.0191H332.263V66.7413H324.536ZM324.536 57.7321V50.01H332.263V57.7321H324.536ZM324.536 48.723V41.0008H332.263V48.723H324.536ZM216.909 94.8719H224.636V102.962H216.909V94.8719ZM324.536 103.146V95.0558H332.263V103.146H324.536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.037 94.8719L219.854 93.7687C222.245 93.401 224.453 92.6656 226.293 91.5624C231.444 88.2529 233.1 82.7371 234.756 77.4052C236.411 72.0732 238.067 67.109 242.667 64.9027C246.162 63.4318 249.658 64.1672 250.762 64.5349C256.465 66.1897 258.673 71.7055 260.697 77.0374C262.536 81.634 264.192 85.8627 267.872 86.782C270.447 87.5175 272.471 86.0466 275.047 84.3919C277.806 82.3694 281.302 79.9792 287.005 79.7954C291.789 79.6115 294.732 81.0824 297.308 82.3694C299.884 83.6564 301.724 84.5757 304.851 83.6564C308.163 82.7371 310.003 80.3469 312.026 77.589C314.234 74.6473 316.81 71.3378 321.961 69.4992C324.353 68.5799 327.112 68.2122 329.872 68.396V69.4992C327.296 69.3153 324.721 69.683 322.329 70.6023C317.546 72.2571 315.154 75.3827 312.762 78.3245C310.738 81.0824 308.715 83.6564 305.035 84.7596C301.54 85.8627 299.148 84.5757 296.756 83.2887C294.364 82.0017 291.605 80.7147 287.005 80.8985C281.67 81.0824 278.542 83.4726 275.599 85.3112C273.023 87.1498 270.815 88.8045 267.688 87.8852C263.456 86.782 261.616 82.1855 259.777 77.4052C257.753 72.4409 255.729 67.109 250.578 65.6381C249.658 65.2704 246.346 64.5349 243.219 66.0058C238.987 67.8444 237.515 72.6248 235.86 77.7729C234.204 83.1048 232.364 89.1722 226.845 92.4817C225.005 93.5849 222.613 94.5042 220.037 94.8719Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.405 83.1048L219.669 82.3694C227.212 76.302 234.939 72.9925 243.034 72.4409C249.289 72.0732 253.337 73.3602 256.648 74.4634C259.96 75.5666 262.72 76.4859 266.215 75.015C271.919 72.8087 274.126 66.7413 276.702 60.49C279.278 53.8711 282.037 46.8844 289.029 44.678C290.132 44.3103 292.892 43.5749 296.02 44.3103C302.459 45.9651 305.219 52.7679 308.346 59.9384C311.29 67.109 314.417 74.6473 321.409 77.589C324.352 78.876 327.664 79.2438 331.343 78.6922L331.527 79.7953C327.664 80.3469 324.168 79.9792 321.041 78.6922C313.682 75.5666 310.554 67.8444 307.426 60.49C304.483 53.5033 301.907 46.8844 295.836 45.4135C292.892 44.678 290.5 45.4135 289.396 45.7812C282.773 47.8037 280.382 54.0549 277.622 60.8577C275.23 67.109 272.654 73.5441 266.583 75.9343C262.72 77.4052 259.776 76.4859 256.464 75.3827C253.153 74.2795 249.289 72.9925 243.218 73.3602C235.307 74.0957 227.58 77.2213 220.405 83.1048Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.441 41.5524H374.394V72.6248H370.346V41.5524H366.299C368.323 37.8752 370.346 34.198 372.37 30.5208C374.394 34.198 376.418 37.8752 378.441 41.5524Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.916 47.0682H352.868V72.6248H348.821V47.0682H344.773C346.797 43.391 348.821 39.7138 350.845 36.0366C352.868 39.8977 354.892 43.5749 356.916 47.0682Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.265 30.5208H179.93V35.8528H185.265V30.5208Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.464 30.5208H189.129V35.8528H194.464V30.5208Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.265 39.8977H179.93V45.2296H185.265V39.8977Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.464 39.8977H189.129V45.2296H194.464V39.8977Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.102 49.0907H142.767V54.4226H148.102V49.0907Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.265 49.0907H179.93V54.4226H185.265V49.0907Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.464 49.0907H189.129V54.4226H194.464V49.0907Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.265 58.2837H179.93V63.6156H185.265V58.2837Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.464 58.2837H189.129V63.6156H194.464V58.2837Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.882 30.5208H170.547V35.8528H175.882V30.5208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.903 39.8977H133.567V45.2296H138.903V39.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.102 39.8977H142.767V45.2296H148.102V39.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 39.8977H152.148V45.2296H157.484V39.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 39.8977H161.348V45.2296H166.683V39.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.882 39.8977H170.547V45.2296H175.882V39.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.903 49.0907H133.567V54.4226H138.903V49.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 49.0907H152.148V54.4226H157.484V49.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 49.0907H161.348V54.4226H166.683V49.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.882 49.0907H170.547V54.4226H175.882V49.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.903 58.2837H133.567V63.6156H138.903V58.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.102 58.2837H142.767V63.6156H148.102V58.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 58.2837H152.148V63.6156H157.484V58.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 58.2837H161.348V63.6156H166.683V58.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.882 58.2837H170.547V63.6156H175.882V58.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.903 67.6606H133.567V72.9925H138.903V67.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.102 67.6606H142.767V72.9925H148.102V67.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 67.6606H152.148V72.9925H157.484V67.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 67.6606H161.348V72.9925H166.683V67.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.882 67.6606H170.547V72.9925H175.882V67.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.484 30.5208H152.148V35.8528H157.484V30.5208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 30.5208H161.348V35.8528H166.683V30.5208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.442 90.4592H344.958V91.7463H378.442V90.4592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.442 96.1589H344.958V97.4459H378.442V96.1589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.507 102.042H344.958V103.329H368.507V102.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.442 78.8761H344.958V80.1631H378.442V78.8761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.442 84.5757H344.958V85.8627H378.442V84.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.117 14.1572H133.567V15.4443H157.117V14.1572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.203 18.5699H133.567V19.8569H172.203V18.5699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.723 14.1572H216.174V15.4443H239.723V14.1572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.809 18.5699H216.174V19.8569H254.809V18.5699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.397 113.442H344.773V120.061H351.397V113.442Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.441 116.2H355.444V117.487H378.441V116.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.397 127.967H344.773V134.586H351.397V127.967Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.441 130.541H355.444V131.828H378.441V130.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.323 221H15.2701C6.80717 221 0 214.197 0 205.74V89.3561C0 80.8985 6.80717 74.0957 15.2701 74.0957H306.507C314.97 74.0957 321.777 80.8985 321.777 89.3561V205.74C321.593 214.197 314.786 221 306.323 221Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.636 111.787H16.9258V114.913H100.636V111.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.636 127.599H16.9258V130.725H100.636V127.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.636 143.595H16.9258V146.72H100.636V143.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5909 111.787H16.9258V114.913H73.5909V111.787Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8904 127.599H16.9258V130.725H44.8904V127.599Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8401 143.595H16.9258V146.72H63.8401V143.595Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6738 106.087H16.9258V107.374H49.6738V106.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6738 121.899H16.9258V123.186H49.6738V121.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6738 137.711H16.9258V138.998H49.6738V137.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4749 88.8045H16.9258V90.0915H40.4749V88.8045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5611 93.0333H16.9258V94.3203H55.5611V93.0333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.615 136.24H118.85V137.527H137.615V136.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.758 140.469H118.85V141.756H149.758V140.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.473 136.24H168.707V137.527H187.473V136.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.615 140.469H168.707V141.756H199.615V140.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33 136.24H218.564V137.527H237.33V136.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.473 140.469H218.564V141.756H249.473V140.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.19 135.873H268.424V137.16H287.19V135.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.332 140.285H268.424V141.572H299.332V140.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.758 144.698H118.85V145.985H149.758V144.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.615 144.698H168.707V145.985H199.615V144.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.473 144.698H218.564V145.985H249.473V144.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.332 144.514H268.424V145.801H299.332V144.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.615 124.29C126.761 124.29 117.93 115.464 117.93 104.616C117.93 93.7687 126.761 84.9434 137.615 84.9434C148.47 84.9434 157.301 93.7687 157.301 104.616C157.117 115.464 148.286 124.29 137.615 124.29ZM137.615 86.9659C127.864 86.9659 119.953 94.8719 119.953 104.616C119.953 114.361 127.864 122.267 137.615 122.267C147.366 122.267 155.277 114.361 155.277 104.616C155.277 94.8719 147.366 86.9659 137.615 86.9659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.414 93.7687C148.102 89.5399 142.951 86.9659 137.615 86.9659V84.9434C143.686 84.9434 149.206 87.7013 153.069 92.4817L151.414 93.7687Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.289 124.29C176.434 124.29 167.604 115.464 167.604 104.616C167.604 93.7687 176.434 84.9434 187.289 84.9434C198.144 84.9434 206.975 93.7687 206.975 104.616C206.975 115.464 198.144 124.29 187.289 124.29ZM187.289 86.9659C177.538 86.9659 169.627 94.8719 169.627 104.616C169.627 114.361 177.538 122.267 187.289 122.267C197.04 122.267 204.951 114.361 204.951 104.616C204.951 94.8719 197.04 86.9659 187.289 86.9659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.975 104.616H204.951C204.951 94.8719 197.04 86.9659 187.289 86.9659V84.9434C198.144 85.1273 206.975 93.7687 206.975 104.616Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.147 124.29C226.292 124.29 217.461 115.464 217.461 104.616C217.461 93.7687 226.292 84.9434 237.147 84.9434C248.001 84.9434 256.832 93.7687 256.832 104.616C256.832 115.464 248.001 124.29 237.147 124.29ZM237.147 86.9659C227.396 86.9659 219.485 94.8719 219.485 104.616C219.485 114.361 227.396 122.267 237.147 122.267C246.897 122.267 254.808 114.361 254.808 104.616C254.808 94.8719 246.897 86.9659 237.147 86.9659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.146 124.29V122.267C246.897 122.267 254.808 114.361 254.808 104.616C254.808 94.8719 246.897 86.9659 237.146 86.9659V84.9434C248.001 84.9434 256.832 93.7687 256.832 104.616C256.832 115.464 248.001 124.29 237.146 124.29Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.005 124.29C276.15 124.29 267.319 115.464 267.319 104.616C267.319 93.7687 276.15 84.9434 287.005 84.9434C297.86 84.9434 306.691 93.7687 306.691 104.616C306.691 115.464 297.86 124.29 287.005 124.29ZM287.005 86.9659C277.254 86.9659 269.343 94.8719 269.343 104.616C269.343 114.361 277.254 122.267 287.005 122.267C296.756 122.267 304.667 114.361 304.667 104.616C304.667 94.8719 296.756 86.9659 287.005 86.9659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.005 124.29C276.15 124.29 267.319 115.464 267.319 104.616H269.343C269.343 114.361 277.254 122.267 287.005 122.267C296.756 122.267 304.667 114.361 304.667 104.616C304.667 94.8719 296.756 86.9659 287.005 86.9659V84.9434C297.86 84.9434 306.691 93.7687 306.691 104.616C306.691 115.464 297.86 124.29 287.005 124.29Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 161.429H16.9258V162.716H50.7777V161.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 167.129H16.9258V168.416H50.7777V167.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 173.012H16.9258V174.3H50.7777V173.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 178.712H16.9258V179.999H50.7777V178.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 184.596H16.9258V185.883H50.7777V184.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 190.295H16.9258V191.582H50.7777V190.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 161.429H66.2314V162.716H100.083V161.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 167.129H66.2314V168.416H100.083V167.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 173.012H66.2314V174.3H100.083V173.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 178.712H66.2314V179.999H100.083V178.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 184.596H66.2314V185.883H100.083V184.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.083 190.295H66.2314V191.582H100.083V190.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.887 200.04C141.662 196.179 146.077 203.349 158.22 201.879C173.858 200.04 180.849 186.067 194.647 186.986C198.879 187.354 201.639 187.905 201.639 187.905C207.894 189.376 210.102 191.766 215.805 192.686C218.381 193.053 220.404 192.869 222.06 192.869C237.33 191.766 245.793 180.551 261.247 179.999C262.351 179.999 267.503 179.815 273.574 182.022C284.428 185.883 291.236 194.156 295.283 198.937C297.859 202.062 299.699 205.004 300.802 206.843C260.511 206.843 139.27 206.843 118.849 206.843C121.24 204.636 124.736 201.695 129.887 200.04Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.954 208.13H118.297V163.084H119.585V206.843H305.954V208.13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.692 360.222C455.539 361.34 454.625 362.102 453.508 361.848C452.746 361.695 452.085 360.933 452.035 360.121C451.831 359.664 451.933 359.105 452.136 358.597C452.39 357.987 453.152 357.683 453.762 357.632C455.082 357.581 455.844 359.003 455.692 360.222Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.022 360.527C368.784 360.781 369.241 361.39 369.241 362.203C369.241 362.914 368.784 363.473 368.276 363.879C367.21 364.692 365.229 363.727 365.584 362.305C365.635 362.102 365.737 361.898 365.838 361.746C366.194 360.883 367.159 360.222 368.022 360.527Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.968 386.483C402.968 386.584 402.917 386.686 402.917 386.787C402.917 386.838 402.917 386.889 402.917 386.94C402.917 386.99 402.917 386.99 402.917 387.041C402.765 387.905 402.409 388.616 401.597 389.022C400.835 389.429 400.124 389.276 399.412 388.768C397.584 387.397 399.057 384.197 401.292 384.603C401.343 384.603 401.393 384.654 401.444 384.654C402.308 384.857 402.917 385.619 402.968 386.483Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.276 397.86C433.038 397.86 433.596 398.317 433.85 399.029C433.952 399.283 433.952 399.536 434.003 399.841C434.003 399.892 433.952 399.994 433.952 400.044C433.952 400.095 433.952 400.095 433.952 400.146C433.901 400.298 433.901 400.502 433.8 400.603C433.749 400.705 433.698 400.756 433.647 400.857C433.596 400.959 433.546 401.009 433.444 401.06C433.342 401.162 433.241 401.213 433.139 401.263C433.038 401.314 432.987 401.365 432.885 401.416C432.835 401.416 432.835 401.467 432.784 401.467C432.631 401.517 432.53 401.517 432.377 401.517C432.377 401.517 432.377 401.517 432.327 401.517C431.92 401.517 431.615 401.416 431.311 401.213C431.311 401.213 431.26 401.213 431.26 401.162C431.209 401.162 431.209 401.111 431.158 401.111C430.803 400.806 430.549 400.4 430.549 399.892C430.549 399.79 430.549 399.74 430.6 399.638C430.6 399.587 430.6 399.536 430.6 399.435V399.384C430.65 399.13 430.701 398.927 430.803 398.673C431.108 398.216 431.768 397.911 432.276 397.86Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.496 358.749C418.41 358.749 418.969 359.867 418.41 360.527C418.207 360.883 417.75 361.086 417.292 360.984C417.242 360.984 417.242 360.984 417.191 360.933C417.14 360.933 417.089 360.883 417.089 360.883C416.886 360.781 416.734 360.629 416.632 360.425C416.175 359.765 416.581 358.749 417.496 358.749Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.978 306.737C426.587 306.635 427.197 307.092 427.501 307.6C427.857 308.159 427.806 308.717 427.552 309.327C427.451 309.53 427.298 309.733 427.146 309.886C427.095 309.937 427.095 309.937 427.044 309.987C426.993 310.038 426.993 310.038 426.993 310.038C426.689 310.648 425.876 310.902 425.216 310.749C424.454 310.546 424.047 309.987 423.997 309.276C423.844 308.819 423.844 308.311 424.098 307.905C424.555 307.143 425.165 306.889 425.978 306.737Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.899 330.66C434.359 330.66 434.257 326.698 436.797 326.698C439.337 326.749 439.438 330.66 436.899 330.66Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.057 285.556C444.72 285.556 444.619 281.949 446.955 281.949C449.292 281.949 449.343 285.556 447.057 285.556Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.654 283.067C409.216 283.067 409.114 279.257 411.552 279.257C413.99 279.206 414.092 283.067 411.654 283.067Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.314 286.165C378.232 286.165 378.181 282.965 380.263 282.965C382.295 282.965 382.397 286.165 380.314 286.165Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.089 304.959C365.991 304.959 365.838 300.133 368.987 300.133C372.086 300.133 372.187 304.959 369.089 304.959Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59 288.552C325.762 288.552 325.711 285.708 327.54 285.708C329.368 285.708 329.419 288.552 327.59 288.552Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.206 350.876C351.819 350.876 351.717 347.168 354.105 347.168C356.492 347.117 356.594 350.876 354.206 350.876Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.657 326.952C328.708 328.171 327.641 329.289 326.422 329.289C325.914 329.289 325.406 329.136 325 328.832V325.124C325.356 324.87 325.813 324.667 326.27 324.667C327.54 324.717 328.606 325.683 328.657 326.952Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.876 389.124C348.162 389.124 348.264 392.679 345.978 392.679C343.692 392.679 343.591 389.124 345.876 389.124Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.981 386.584C375.54 385.67 376.809 385.568 377.419 386.533C377.419 386.533 377.419 386.584 377.47 386.584C377.52 386.635 377.571 386.686 377.622 386.787C377.876 387.194 377.876 387.752 377.673 388.108C377.419 388.514 377.114 388.819 376.657 388.921C375.438 389.175 374.219 387.956 374.879 386.737C374.879 386.737 374.93 386.686 374.981 386.584Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.104 407.206C371.73 407.206 372.288 408.832 371.831 409.949H368.479C367.971 408.832 368.479 407.206 370.104 407.206Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.549 367.74C336.784 367.74 336.835 371.194 334.651 371.194C332.416 371.143 332.314 367.74 334.549 367.74Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.759 326.241C395.603 326.241 395.756 330.711 392.86 330.711C390.016 330.66 389.864 326.241 392.759 326.241Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 401.365V398.013C326.981 398.165 327.032 401.263 325 401.365Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.118 353.162C390.372 352.756 390.88 352.4 391.387 352.603C391.438 352.603 391.489 352.654 391.54 352.654C392.556 353.01 392.657 354.381 391.591 354.736C391.54 354.736 391.489 354.787 391.438 354.787C390.981 354.94 390.372 354.686 390.168 354.279C389.965 353.975 389.914 353.568 390.118 353.263C390.067 353.213 390.118 353.162 390.118 353.162Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.204 380.692C357.204 380.641 357.254 380.641 357.254 380.59C357.508 380.184 358.016 379.829 358.524 380.032C358.575 380.032 358.626 380.083 358.677 380.083C359.692 380.438 359.794 381.81 358.727 382.165C358.677 382.165 358.626 382.216 358.575 382.216C358.118 382.368 357.508 382.114 357.305 381.708C357.102 381.403 357 380.997 357.204 380.692Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.454 326.444C360.454 326.394 360.504 326.394 360.504 326.343C360.758 325.937 361.266 325.581 361.774 325.784C361.825 325.784 361.876 325.835 361.927 325.835C362.942 326.19 363.044 327.562 361.977 327.917C361.927 327.917 361.876 327.968 361.825 327.968C361.368 328.121 360.758 327.867 360.555 327.46C360.352 327.156 360.25 326.8 360.454 326.444Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.838 273.771C429.787 273.771 429.736 273.822 429.685 273.822C429.228 273.975 428.619 273.721 428.415 273.314C428.212 273.01 428.162 272.603 428.365 272.298C428.365 272.248 428.415 272.248 428.415 272.197C428.669 271.79 429.177 271.435 429.685 271.638C429.736 271.638 429.787 271.689 429.838 271.689C430.803 272.044 430.955 273.365 429.838 273.771Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.861 387.803C457.115 387.397 457.623 387.041 458.131 387.244C458.181 387.244 458.232 387.295 458.283 387.295C459.299 387.651 459.4 389.022 458.334 389.378C458.283 389.378 458.232 389.429 458.181 389.429C457.724 389.581 457.115 389.327 456.912 388.921C456.708 388.616 456.658 388.21 456.861 387.905C456.81 387.854 456.81 387.854 456.861 387.803Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.206 267.067C369.343 267.067 368.784 266.61 368.53 266H371.883C371.578 266.61 371.07 267.067 370.206 267.067Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.035 327.105C468.035 326.343 468.391 325.632 469 325.175V328.883C468.442 328.476 468.035 327.816 468.035 327.105Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.797 398.013C468.847 398.013 468.898 398.013 468.949 398.013V401.365C468.898 401.365 468.898 401.365 468.847 401.365C466.714 401.365 466.663 398.013 468.797 398.013Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.486 347.623C394.215 347.866 394.653 348.45 394.653 349.228C394.653 349.908 394.215 350.443 393.729 350.832C392.708 351.61 390.811 350.687 391.152 349.325C391.2 349.13 391.298 348.936 391.395 348.79C391.735 347.963 392.659 347.331 393.486 347.623Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.941 372.471C426.941 372.569 426.893 372.666 426.893 372.763C426.893 372.812 426.893 372.86 426.893 372.909C426.893 372.958 426.893 372.958 426.893 373.006C426.747 373.833 426.406 374.514 425.628 374.903C424.899 375.292 424.218 375.146 423.537 374.66C421.787 373.347 423.197 370.283 425.337 370.672C425.385 370.672 425.434 370.721 425.483 370.721C426.309 370.915 426.893 371.645 426.941 372.471Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.999 383.364C455.728 383.364 456.263 383.802 456.506 384.482C456.604 384.725 456.604 384.969 456.652 385.26C456.652 385.309 456.604 385.406 456.604 385.455C456.604 385.504 456.604 385.504 456.604 385.552C456.555 385.698 456.555 385.893 456.458 385.99C456.409 386.087 456.361 386.136 456.312 386.233C456.263 386.33 456.215 386.379 456.117 386.427C456.02 386.525 455.923 386.573 455.826 386.622C455.728 386.671 455.68 386.719 455.583 386.768C455.534 386.768 455.534 386.816 455.485 386.816C455.339 386.865 455.242 386.865 455.096 386.865C455.096 386.865 455.096 386.865 455.048 386.865C454.659 386.865 454.367 386.768 454.075 386.573C454.075 386.573 454.026 386.573 454.026 386.525C453.978 386.525 453.978 386.476 453.929 386.476C453.589 386.184 453.346 385.795 453.346 385.309C453.346 385.212 453.346 385.163 453.394 385.066C453.394 385.017 453.394 384.969 453.394 384.871V384.823C453.443 384.58 453.492 384.385 453.589 384.142C453.881 383.704 454.513 383.413 454.999 383.364Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.849 345.921C441.724 345.921 442.259 346.991 441.724 347.623C441.53 347.963 441.092 348.158 440.655 348.061C440.606 348.061 440.606 348.061 440.557 348.012C440.509 348.012 440.46 347.963 440.46 347.963C440.266 347.866 440.12 347.72 440.022 347.526C439.585 346.894 439.974 345.921 440.849 345.921Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.97 296.127C449.553 296.03 450.137 296.467 450.428 296.954C450.769 297.488 450.72 298.023 450.477 298.607C450.38 298.801 450.234 298.996 450.088 299.142C450.039 299.19 450.039 299.19 449.991 299.239C449.942 299.288 449.942 299.288 449.942 299.288C449.65 299.871 448.872 300.114 448.24 299.968C447.511 299.774 447.122 299.239 447.073 298.558C446.927 298.121 446.927 297.634 447.17 297.245C447.608 296.516 448.192 296.273 448.97 296.127Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.425 319.03C456.993 319.03 456.896 315.237 459.327 315.237C461.759 315.286 461.856 319.03 459.425 319.03Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.15 275.849C466.913 275.849 466.816 272.397 469.053 272.397C471.29 272.397 471.338 275.849 469.15 275.849Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.257 273.467C432.923 273.467 432.826 269.82 435.16 269.82C437.494 269.771 437.591 273.467 435.257 273.467Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.254 276.433C403.26 276.433 403.212 273.369 405.206 273.369C407.151 273.369 407.248 276.433 405.254 276.433Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.507 294.425C391.541 294.425 391.395 289.805 394.41 289.805C397.376 289.805 397.474 294.425 394.507 294.425Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.779 278.718C353.028 278.718 352.98 275.995 354.73 275.995C356.481 275.995 356.529 278.718 354.779 278.718Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26 338.384C377.974 338.384 377.877 334.834 380.162 334.834C382.448 334.785 382.545 338.384 380.26 338.384Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8 315.48C355.849 316.648 354.827 317.717 353.66 317.717C353.174 317.717 352.688 317.571 352.299 317.28V313.73C352.639 313.487 353.077 313.292 353.515 313.292C354.73 313.341 355.751 314.265 355.8 315.48Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.285 375C374.473 375 374.57 378.404 372.382 378.404C370.194 378.404 370.097 375 372.285 375Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.148 372.569C400.683 371.693 401.899 371.596 402.482 372.52C402.482 372.52 402.482 372.569 402.531 372.569C402.58 372.617 402.628 372.666 402.677 372.763C402.92 373.152 402.92 373.687 402.725 374.028C402.482 374.417 402.191 374.708 401.753 374.806C400.586 375.049 399.419 373.882 400.051 372.715C400.051 372.715 400.1 372.666 400.148 372.569Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.48 392.311C397.036 392.311 397.571 393.867 397.133 394.937H393.924C393.438 393.867 393.924 392.311 395.48 392.311Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.441 354.528C363.58 354.528 363.629 357.835 361.538 357.835C359.398 357.786 359.301 354.528 361.441 354.528Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.167 314.8C419.89 314.8 420.036 319.079 417.265 319.079C414.541 319.03 414.396 314.8 417.167 314.8Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.299 386.719V383.51C354.195 383.656 354.244 386.622 352.299 386.719Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.638 340.572C414.882 340.183 415.368 339.843 415.854 340.037C415.903 340.037 415.951 340.086 416 340.086C416.973 340.426 417.07 341.739 416.049 342.08C416 342.08 415.951 342.128 415.903 342.128C415.465 342.274 414.882 342.031 414.687 341.642C414.493 341.35 414.444 340.961 414.638 340.669C414.59 340.621 414.638 340.572 414.638 340.572Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.128 366.928C383.128 366.879 383.177 366.879 383.177 366.831C383.42 366.442 383.907 366.101 384.393 366.296C384.441 366.296 384.49 366.344 384.539 366.344C385.511 366.685 385.608 367.998 384.587 368.338C384.539 368.338 384.49 368.387 384.441 368.387C384.004 368.533 383.42 368.29 383.226 367.901C383.031 367.609 382.934 367.22 383.128 366.928Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.241 314.994C386.241 314.946 386.289 314.946 386.289 314.897C386.533 314.508 387.019 314.168 387.505 314.362C387.554 314.362 387.602 314.411 387.651 314.411C388.624 314.751 388.721 316.064 387.7 316.404C387.651 316.404 387.602 316.453 387.554 316.453C387.116 316.599 386.533 316.356 386.338 315.967C386.144 315.675 386.046 315.335 386.241 314.994Z",
    fill: "#E3E5FC"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.46 201.276L377.92 229.592C381.544 230.787 383.482 235.004 382.105 238.751L381.885 239.375C380.673 242.684 377.107 244.252 374 242.912L289.386 206.386L292.46 201.276Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M298.266 183.439C298.034 162.503 280.53 145.725 259.17 145.965C237.81 146.204 220.682 163.37 220.914 184.306C221.145 205.242 238.649 222.02 260.009 221.78C281.369 221.541 298.497 204.375 298.266 183.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.548 184.344C216.816 207.621 236.288 226.288 260.053 226.028C283.818 225.768 302.887 206.662 302.65 183.383C302.382 160.105 282.909 141.438 259.113 141.7C235.348 141.96 216.279 161.066 216.548 184.344ZM222.859 184.286C222.646 164.416 238.91 148.104 259.196 147.872C279.482 147.639 296.095 163.572 296.308 183.442C296.521 203.312 280.256 219.593 259.969 219.826C239.714 220.057 223.072 204.155 222.859 184.286Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.422 188.5C299.33 188.504 299.296 188.413 299.293 188.352C299.404 187.364 299.484 186.347 299.533 185.361C299.529 185.269 299.619 185.204 299.682 185.232C299.774 185.228 299.839 185.317 299.811 185.38C299.763 186.396 299.683 187.413 299.572 188.401C299.574 188.432 299.515 188.496 299.422 188.5ZM298.846 176.604C298.33 173.923 297.538 171.284 296.475 168.78C293.456 161.659 288.391 155.641 281.83 151.347C275.11 146.937 267.28 144.634 259.154 144.74C251.519 144.825 244.13 147.019 237.778 151.103C237.717 151.137 237.625 151.141 237.56 151.051C237.526 150.991 237.522 150.899 237.612 150.834C244.026 146.747 251.475 144.519 259.14 144.433C267.299 144.357 275.22 146.625 281.972 151.065C288.565 155.388 293.664 161.466 296.746 168.645C297.811 171.18 298.633 173.817 299.151 176.529C299.155 176.621 299.127 176.684 299.035 176.688C299.035 176.688 299.035 176.688 299.004 176.689C298.943 176.723 298.879 176.664 298.846 176.604Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.861 241.405C376.892 241.404 376.892 241.404 376.922 241.403C379.493 240.308 380.807 238.654 380.774 236.474C380.742 234.293 379.363 232.325 377.267 231.586L366.849 227.828C366.725 227.803 366.603 227.839 366.577 227.963C366.552 228.086 366.588 228.208 366.714 228.264L377.131 231.992C379.008 232.678 380.318 234.465 380.312 236.463C380.335 238.428 379.139 239.955 376.749 240.949C376.627 240.985 376.572 241.141 376.639 241.261C376.674 241.352 376.769 241.409 376.861 241.405Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.539,
    cy: 183.697,
    rx: 37,
    ry: 36,
    transform: "rotate(-2.47822 259.539 183.697)",
    fill: "white",
    fillOpacity: 0.7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.583 214.339C305.183 215.639 306.583 215.739 307.483 216.839C307.883 217.339 308.283 218.039 308.383 219.239C309.583 219.339 310.783 219.339 311.983 219.439C312.083 218.639 312.183 217.939 312.283 217.539C312.283 217.239 312.383 216.939 312.483 216.539C312.583 216.039 312.583 215.539 312.683 214.939C312.683 214.039 312.583 213.539 312.283 213.339C312.283 213.339 311.883 213.039 311.483 213.139C311.483 213.139 311.383 213.239 311.183 213.439C310.883 213.939 311.183 214.239 310.983 214.639C310.883 214.839 310.783 215.039 310.183 215.339C308.283 214.539 306.383 213.739 304.383 212.839C304.383 213.239 304.383 213.739 304.583 214.339Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.583 235.339C352.583 235.739 352.583 236.239 352.383 236.939C353.383 237.539 354.283 238.139 355.283 238.739C355.383 238.439 355.583 238.239 355.783 238.039C355.883 237.839 356.183 237.539 356.683 237.339C357.783 236.839 358.483 237.739 359.983 237.439C360.383 237.339 360.683 237.239 360.883 237.139C358.583 236.139 356.283 235.139 353.983 234.139C353.983 233.939 353.983 233.639 353.983 233.239C353.983 232.639 354.083 232.439 353.883 232.239C353.683 231.939 353.283 231.839 352.983 231.939C352.783 232.039 352.583 232.239 352.483 232.739C352.383 233.039 352.383 233.339 352.383 233.439C352.383 233.539 352.383 233.639 352.383 233.639C352.383 234.339 352.483 234.839 352.583 235.339Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.382 247.939C321.082 248.639 321.882 248.839 321.882 248.839C322.582 249.039 323.182 249.039 323.582 249.039L323.382 251.539C323.582 251.739 324.482 252.339 325.682 252.339C326.682 252.239 327.382 251.739 327.682 251.539C327.782 250.739 327.782 250.239 327.882 249.839H327.782C327.582 249.839 327.482 249.839 327.382 249.839C326.982 249.939 326.782 249.839 326.682 249.739C325.982 249.339 325.982 247.739 326.682 245.639C326.682 245.639 327.382 246.139 328.082 245.939C328.182 245.939 328.682 245.739 328.882 245.139C329.082 244.539 328.882 243.839 328.482 243.639C327.982 243.339 327.382 243.839 327.082 243.639C326.582 243.139 328.882 240.539 328.182 239.339C327.782 238.739 326.882 239.039 324.382 238.639C322.682 238.339 321.582 238.139 320.882 237.739C318.882 241.439 319.082 246.639 320.382 247.939Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.382 237.239C320.482 237.539 320.682 237.739 320.982 237.839C321.682 238.239 322.782 238.439 324.482 238.739C326.982 239.139 327.882 238.839 328.282 239.439C328.982 240.639 326.682 243.239 327.182 243.739C327.482 243.939 328.082 243.439 328.582 243.739C328.982 243.939 329.182 244.639 328.982 245.239C328.782 245.839 328.182 246.039 328.182 246.039C327.482 246.339 326.782 245.739 326.782 245.739C326.382 246.739 326.282 247.639 326.282 248.339C326.282 248.739 326.382 249.439 326.782 249.739C327.182 250.039 327.782 249.839 327.982 249.739C329.282 249.339 330.982 247.339 331.782 244.339C332.982 239.639 330.882 236.039 330.282 235.539C329.982 235.239 329.682 235.139 329.582 235.039C328.682 234.439 327.882 234.339 326.982 234.239H326.882C326.782 234.239 326.682 234.239 326.582 234.239C326.482 234.239 326.382 234.239 326.382 234.239C325.582 234.139 324.582 234.139 323.282 233.839C322.482 233.639 322.182 233.539 321.782 233.739C320.582 234.139 319.782 236.039 320.382 237.239Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.083 285.439C314.283 305.839 314.383 329.039 314.583 349.439H319.583C321.583 335.939 323.583 321.239 325.583 306.939C328.183 321.239 331.283 335.839 333.083 349.339H338.383C337.983 328.039 337.683 306.739 337.383 285.439C329.583 285.439 321.883 285.439 314.083 285.439Z",
    fill: "#433082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.483 355.339C327.483 355.539 327.683 355.639 327.783 355.639H337.383C337.583 355.639 337.683 355.439 337.683 355.339V349.439H333.983C333.983 349.539 333.983 349.639 333.983 349.739C334.083 351.139 334.083 351.539 333.883 351.939C333.483 352.639 332.783 352.839 331.683 353.339C330.683 353.739 329.283 354.239 327.583 355.039C327.583 355.039 327.483 355.239 327.483 355.339Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.783 355.239C337.783 355.439 337.583 355.539 337.483 355.539H327.883C327.683 355.539 327.583 355.439 327.583 355.239C327.583 355.039 327.583 354.939 327.783 354.839C329.483 354.039 330.883 353.439 331.883 353.139C331.883 353.139 331.983 353.139 331.983 353.039H337.883V355.239H337.783Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.683 355.339C308.683 355.539 308.883 355.639 308.983 355.639H318.583C318.783 355.639 318.883 355.439 318.883 355.339V349.539H315.183V349.739C315.083 351.439 314.983 351.839 314.783 352.139C314.383 352.739 313.883 352.939 312.883 353.339C311.883 353.739 309.383 354.839 308.783 355.039C308.683 355.039 308.683 355.239 308.683 355.339Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.883 355.239C318.883 355.439 318.683 355.539 318.583 355.539H308.983C308.783 355.539 308.683 355.439 308.683 355.239C308.683 355.039 308.683 354.939 308.883 354.839C309.483 354.539 311.983 353.439 312.983 353.139C312.983 353.139 313.083 353.139 313.083 353.039H318.883V355.239Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.883 219.239C307.883 222.239 307.983 232.039 309.283 240.539C309.883 244.839 311.183 248.839 311.183 248.839C311.383 249.639 311.583 250.339 311.783 250.839C312.083 251.939 312.383 252.639 312.383 252.839C313.083 254.839 313.383 257.739 313.383 258.539C313.883 263.839 313.783 267.339 313.783 267.339C313.683 272.139 313.783 276.139 313.883 285.439C321.183 285.439 329.783 285.339 337.083 285.339C336.683 279.039 336.383 273.439 336.183 268.639C336.083 267.239 336.083 265.139 337.083 262.839C338.283 260.139 340.383 258.539 341.783 257.739C341.783 257.739 346.083 255.439 350.083 250.639C351.883 248.739 354.483 245.039 355.683 239.039C355.583 238.939 355.383 238.839 355.283 238.739C354.283 238.139 351.983 236.639 351.783 236.539C351.283 238.539 349.183 246.039 342.283 250.139C340.583 251.139 336.683 253.539 331.683 252.639C329.983 252.339 328.583 251.739 327.683 251.239C327.483 251.439 326.783 252.039 325.683 252.139C324.383 252.239 323.483 251.539 323.383 251.339C322.583 251.339 321.283 251.339 320.083 250.639C318.183 249.639 317.383 247.839 316.683 246.239C314.383 240.239 313.083 230.939 312.883 229.239C312.683 228.039 312.483 226.739 312.383 225.239C312.283 222.939 312.383 220.939 312.583 219.239C312.383 219.239 312.183 219.239 311.983 219.239C310.883 219.339 308.083 219.239 307.883 219.239Z",
    fill: "#FB911B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.61798,
    y1: 113.37,
    x2: 86.4443,
    y2: 113.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -2.61798,
    y1: 129.211,
    x2: 86.4452,
    y2: 129.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -2.61798,
    y1: 145.051,
    x2: 86.445,
    y2: 145.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 137.553,
    y1: 89.421,
    x2: 152.975,
    y2: 89.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 187.373,
    y1: 94.8631,
    x2: 206.971,
    y2: 94.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 237.193,
    y1: 104.656,
    x2: 256.792,
    y2: 104.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 267.417,
    y1: 104.656,
    x2: 306.613,
    y2: 104.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 108.153,
    y1: 185.079,
    x2: 294.577,
    y2: 203.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 291.762,
    y1: 201.971,
    x2: 384.491,
    y2: 239.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 218.083,
    y1: 161.302,
    x2: 294.952,
    y2: 203.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 395,
    height: 221,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "white",
    transform: "translate(325 266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.858,
    height: 137.858,
    fill: "white",
    transform: "translate(352.299 257.128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 107,
    fill: "white",
    transform: "translate(214.763 143.596) rotate(-2.47822)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.5,
    height: 142.8,
    fill: "white",
    transform: "matrix(-1 0 0 1 360.883 212.839)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorEditImg);
export default __webpack_public_path__ + "static/media/competitor_edit_img.7dc1e76c.svg";
export { ForwardRef as ReactComponent };